import { Fade, LinearProgress } from "@mui/material";
import React, { Component } from "react";

export default class LoadingBar extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      loading: this.props.loading ? this.props.loading : false,
      loadingReason: null,
    };
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.loading !== this.props.loading)
      this.setState({ loading: this.props.loading });
  }

  render() {
    const { loading } = this.state;

    return (
      <Fade in={loading}>
        <LinearProgress className="klayo-loadingbar" />
      </Fade>
    );
  }

  setLoading(loading: any) {
    this.setState({ loading });
  }
}
